import React from 'react'
import { TableRow } from '@mui/material'
import { TableCellWidth } from '@app/src/components/Table'
import TableHeaderCell from '@app/src/components/Table/Cells/TableHeaderCell'
import { useIntl } from 'react-intl'
import { useOwnerRestriction } from '@app/src/hooks/useOwnerRestriction'

const InvitationHeader: React.FC = () => {
  const { formatMessage } = useIntl()
  const { accountSupportsOwnerRestriction } = useOwnerRestriction()

  return (
    <TableRow>
      <TableHeaderCell label={formatMessage({ id: 'schemas.invitation.name' })} />
      <TableHeaderCell label={formatMessage({ id: 'schemas.invitation.email' })} />
      <TableHeaderCell label={formatMessage({ id: 'schemas.invitation.role' })} />
      {accountSupportsOwnerRestriction && (
        <TableHeaderCell
          label={formatMessage({ id: 'permissions.ownerRestricted.name' })}
          minWidth={TableCellWidth.SMALL}
        />
      )}
      <TableHeaderCell label={formatMessage({ id: 'schemas.invitation.status' })} />
      <TableHeaderCell label={formatMessage({ id: 'schemas.invitation.createdAt' })} />
      <TableHeaderCell label="" minWidth={TableCellWidth.EMPTY} />
    </TableRow>
  )
}

export default InvitationHeader
